/**
 * Section + Detail primitives for the firm detail panel (extracted from
 * firm-detail-panel.tsx). user-detail-panel.tsx keeps its own copies with
 * the same shape — they are intentionally not shared.
 */

import type { ReactNode } from "react";

/** Titled section block. */
export function Section({
  title,
  testId,
  children,
}: {
  title: string;
  testId?: string;
  children: ReactNode;
}) {
  return (
    <section
      className="border-t px-5 py-4 first:border-t-0"
      data-testid={testId}
    >
      <h3 className="mb-2 text-xs font-medium uppercase tracking-wide text-muted-foreground">
        {title}
      </h3>
      {children}
    </section>
  );
}

/** Label/value row inside a section. */
export function Detail({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="flex gap-2 text-sm">
      <dt className="w-28 shrink-0 text-muted-foreground">{label}</dt>
      <dd className="min-w-0 break-words">{value}</dd>
    </div>
  );
}
